export default "__VITE_ASSET__BjQfDM9$__"